import slugify from "slugify";
import { getCompleteSlug } from "@lib/utils/getCompleteSlug";
import { getPagePathByLocale, productDetailPage } from "@lib/constants/pagePaths";
import { getPathname } from "@i18n/routing";

export interface PDPSlugParts {
    sku: string;
    slug: string;
    slugWithLocale: string;
    distributionChannelWhereClause: string;
}

export const getPDPSlug = (
    productName: string,
    articleNumber: string,
    colorCode: string,
    locale: string
): PDPSlugParts => {
    const distributionChannelId = process.env.NEXT_PUBLIC_DISTRIBUTION_CHANNEL_ID;

    if (!distributionChannelId) {
        throw Error("missing NEXT_PUBLIC_DISTRIBUTION_CHANNEL_ID");
    }

    const slug = getCompleteSlug(
        [slugify(productName?.toLowerCase() || ""), articleNumber, colorCode],
        getPagePathByLocale(productDetailPage, locale)
    );
    const slugWithLocale = getPathname({ href: slug, locale });

    return {
        sku: `${articleNumber}${colorCode}`,
        slug,
        slugWithLocale,
        // eslint-disable-next-line no-useless-escape
        distributionChannelWhereClause: `productSelection(id=\"${distributionChannelId}\")`,
    };
};
